import { AxiosResponse } from "axios";
import { Endpoints } from "@phurshell/psiapp-frontend-core/infra";

/**
 * Interceptor de desenvolvimento: sobrescreve a resposta de GET /users/:id
 * para simular estados de assinatura sem depender do backend.
 *
 * Ativado via VUE_APP_MOCK_USER_STATUS no .env.local (ex: "past_due").
 * Não deve rodar fora de ambiente de desenvolvimento.
 */
const MOCK_USER_STATUS = process.env.VUE_APP_MOCK_USER_STATUS;

const isShowUserRequest = (url?: string) => {
  if (!url) return false;
  return new RegExp(`${Endpoints.user}/\\d+$`).test(url.split("?")[0]);
};

// Overrides mínimos aplicados por cima da resposta real do usuário logado,
// preservando os demais dados (nome, avatar, etc) para o teste ficar realista.
const MOCK_OVERRIDES: Record<string, (data: any) => any> = {
  past_due: (data: any) => ({
    ...data,
    approved: false,
    stripe_id: data.stripe_id || "acct_1MockPastDue",
    connect_account: {
      ...data.connect_account,
      currently_due: "",
    },
    subscription: {
      ...data.subscription,
      status: "past_due",
    },
  }),
};

export const mockInterceptor = (response: AxiosResponse<any, any>) => {
  const override = MOCK_USER_STATUS && MOCK_OVERRIDES[MOCK_USER_STATUS];

  if (!override || !isShowUserRequest(response.config?.url)) {
    return response;
  }

  response.data = {
    ...response.data,
    data: override(response.data?.data || {}),
  };

  return response;
};
